<script lang="ts">
  import { formatter } from "$app/utils"
  import { signupStore } from "$app/signupstore.svelte"
</script>

<div class="mt-4 text-gray-600 text-sm font-semibold">
  <div class="grid grid-cols-2 py-1">
    <div class="text-gray-400 font-normal">Total</div>
    <div class="text-right">{formatter.format(signupStore.totalAmount)}</div>
  </div>

  <div class="grid grid-cols-2 py-1">
    <div class="text-gray-400 font-normal">Discount</div>
    <div class="text-right">
      -{formatter.format(signupStore.discount)}
    </div>
  </div>

  <div class="grid grid-cols-2 py-1 border-t border-gray-300">
    <div class="text-gray-400">You pay each {signupStore.billingInterval}</div>
    <div class="text-xl text-black text-right">
      {formatter.format(signupStore.total)}
    </div>
  </div>
</div>
